import {
    configureStore,
    combineReducers,
} from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
import { persistReducer } from "redux-persist";
import cartSlice from "./cartSlice";
import userSlice from "./userSlice";
import paginationSlice from "./paginationSlice";
import courseSlice from "./courseSlice";
import bookCartSlice from "./bookCartSlice";

const reducers = combineReducers({
    cartReducer: cartSlice.reducer,
    userReducer: userSlice.reducer,
    paginationReducer : paginationSlice.reducer,
    courseReducer : courseSlice.reducer,
    bookCartReducer: bookCartSlice.reducer,
});

const persistConfig = {
    key: "root",
    storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(logger),
    devTools: process.env.NODE_ENV !== "production",
});
export default store;
